// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1__fe9d2d6afc8a1e9e9f94","cls2":"Unibrow-cls2___5d67075e23a352ed796 Unibrow-cls1__fe9d2d6afc8a1e9e9f94"};